import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";

export const MassiveRequestList = () => {
  
  return (
    <>
  {/* Page Wrapper */}
  <div id="wrapper">
    {/* Sidebar */}
   <Sidebar/>
    {/* End of Sidebar */}
    {/* Content Wrapper */}
    <div id="content-wrapper" className="d-flex flex-column">
      {/* Main Content */}
      <div id="content">
        {/* Topbar */}
       <Header/>
        {/* End of Topbar */}
        {/* Begin Page Content */}
        <div className="container-fluid">
  <div className="card shadow mb-4">
    <div className="card-header py-3">
      <h6 className="m-0 font-weight-bold text-primary">Massive Requests</h6>
    </div>
    <div className="card-body">
      <div className="table-responsive">
        <table
          className="table table-bordered"
          id="dataTable"
          width="100%"
          cellSpacing={0}
        >
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Baby Name</th>
              <th>Mob No.</th>
              <th>Age/Month</th>
              <th>DOB</th>
              <th>Gender</th>
              <th>Any Disability</th>
              <th>Address</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tiger Nixon</td>
              <td>xhz</td>
              <td>9226333040</td>
              <td>21</td>
              <td>04/05/2001</td>
              <td>Male</td>
              <td>No</td>
              <td>A/P Yadrav</td>
              <td>21/11/2022</td>
              <td>
                <button className="btn btn-primary">update</button>
                <button className="btn btn-danger">delete</button>
              </td>
            </tr>
            <tr>
              <td>Dilip Chungadi</td>
              <td>xyz</td>
              <td>9226363556</td>
              <td>43</td>
              <td>04/05/1980</td>
              <td>Male</td>
              <td>No</td>
              <td>A/P Pune</td>
              <td>21/11/2021</td>
              <td>
                <button className="btn btn-primary">update</button>
                <button className="btn btn-danger">delete</button>
              </td>
            </tr>
            <tr>
              <td>Rohan Tulasankar</td>
              <td>tws</td>
              <td>9226363676</td>
              <td>23</td>
              <td>04/05/1999</td>
              <td>Male</td>
              <td>No</td>
              <td>A/P Jambhali</td>
              <td>21/09/2021</td>
              <td>
                <button className="btn btn-primary">update</button>
                <button className="btn btn-danger">delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>




        {/* /.container-fluid */}
      </div>
      {/* End of Main Content */}
      {/* Footer */}
     <Footer/>
      {/* End of Footer */}
    </div>
    {/* End of Content Wrapper */}
  </div>
  {/* End of Page Wrapper */}
  {/* Scroll to Top Button*/}
  
</>

  );
};
